import api from "../api/axios";

export async function persistVerkaufChanges({ verkaufUrl, streckeId, activeRows, deletedIds, context }) {
  for (const row of activeRows) {
    const payload = { ...row, strecke_id: streckeId, ...context };
    if (row.id) {
      await api.put(`${verkaufUrl}/${row.id}`, payload);
    } else {
      await api.post(verkaufUrl, payload);
    }
  }

  for (const id of deletedIds) {
    if (context) await api.delete(`${verkaufUrl}/${id}`, { data: context });
    else await api.delete(`${verkaufUrl}/${id}`);
  }
}
